import React, { useEffect, useState } from "react";
import { featuredProperties } from "../data/featuredproperties";
import star from "../../../../../assets/icons/star.svg";
import dhoorbin from "../../../../../assets/icons/dhoorbin.svg";
import { useSelector } from "react-redux";
import { IoIosArrowForward } from "react-icons/io";
import { FaHeart } from "react-icons/fa";
import { useNavigate } from "react-router";
import { geAllFeaturedHotels } from "../../../../../api/website/home/homeApi";

const FeaturedProperties = () => {
  const navigate = useNavigate();
  const [Data, setData] = useState([]);
  const [DemoData, setDemoData] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const { checkIn, checkOut } = useSelector((state) => state.search);
  const nights =
    (new Date(checkOut) - new Date(checkIn)) / (1000 * 60 * 60 * 24);

  useEffect(() => {
    setTimeout(() => {
      setDemoData(featuredProperties);
    }, 1000);
  }, []);

  const allRooms = Data.flatMap((section) =>
    section.selectedHotels.flatMap((hotel) => hotel.rooms),
  );

  const lowestPrice = Math.min(...allRooms.map((room) => room.discountedPrice));

  const highestPrice = Math.max(
    ...allRooms.map((room) => room.discountedPrice),
  );

  const maxDiscount = Math.max(...allRooms.map((room) => room.discount));
  useEffect(() => {
    geAllFeaturedHotels(setData, setIsLoading);
  }, []);
  return (
    <>
      {Data.length > 0 ? (
        <>
          {Data.map((item, index) => {
            return (
              <div
                key={index}
                className="bg-white lg:bg-gradient-to-t lg:from-sky-50 lg:to-blue-50 sm:p-0 lg:p-10 rounded-3xl"
              >
                <div className="space-y-3">
                  <div>
                    <h2 className="py-2 font-bold text-xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                      {item.sectionTitle}
                    </h2>
                  </div>
                  <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                    {item?.selectedHotels.map((item, index) => {
                      const lowestPrice = item.rooms?.length
                        ? Math.min(
                            ...item.rooms.map((room) => room.discountedPrice),
                          )
                        : 0;

                      const maxDiscount = item.rooms?.length
                        ? Math.max(...item.rooms.map((room) => room.discount))
                        : 0;

                      return (
                        <div key={index}>
                          <div
                            onClick={() =>
                              navigate(
                                `/hotel/details/${item.id}/${item.hotelName
                                  .toLowerCase()
                                  .replace(/ /g, "-")}`,
                              )
                            }
                            className="bg-white rounded-md  duration-300 cursor-pointer"
                          >
                            {" "}
                            <div className="w-full h-auto rounded-md border flex flex-col gap-y-2 p-2">
                              <div className="relative w-full h-48 rounded-md overflow-hidden">
                                <img
                                  className="w-full h-full object-cover scale-100 hover:scale-105  duration-300"
                                  src={item.images[0].imageLink}
                                  alt={item.hotelName}
                                />
                                {item.isCoupleFriendly === 1 && (
                                  <div className="absolute top-2 right-2 text-white bg-[#ff0062ce] px-2 py-0.5 rounded-full cursor-pointer">
                                    <div className="flex items-center justify-start gap-x-2">
                                      <div className="text-[8px]">
                                        <FaHeart />
                                      </div>
                                      <p className="text-[8px] font-semibold">
                                        Couple Friendly
                                      </p>
                                    </div>
                                  </div>
                                )}
                                {/* <div className="absolute top-2 right-2 text-xl text-[#ff0062] cursor-pointer">
                                  <FaHeart />
                                </div> */}
                                {maxDiscount && (
                                  <div className="absolute top-2 left-2 text-xs font-semibold rounded-full bg-[#153875] text-white px-2 py-0.5">
                                    <p>{maxDiscount}% off</p>
                                  </div>
                                )}
                              </div>
                              <div className="flex items-start gap-x-1">
                                {Array.from({
                                  length: item.propertyStar,
                                }).map((_, i) => {
                                  return (
                                    <div key={i}>
                                      <img
                                        className="w-3 h-3"
                                        src={star}
                                        alt=""
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                              <div>
                                <p className="font-bold text-sm text-[#0d2d63]">
                                  {item.hotelName}
                                </p>
                                <p className="text-[10px] text-black/50">
                                  {item.area}, {item.cityName},{" "}
                                  {item.divisionName}, {item.countryName}
                                </p>
                              </div>
                              <div className="flex flex-wrap justify-start items-center gap-x-2 py-1">
                                {item?.facilities &&
                                  Array.from(
                                    new Set(
                                      item.facilities.flatMap((facGroup) =>
                                        facGroup.facilities.map(
                                          (f) => f.facilityName,
                                        ),
                                      ),
                                    ),
                                  )
                                    .slice(0, 5)
                                    .map((name, index) => {
                                      const fac = item.facilities
                                        .flatMap(
                                          (facGroup) => facGroup.facilities,
                                        )
                                        .find((f) => f.facilityName === name);

                                      return (
                                        <div
                                          key={index}
                                          className="flex justify-start items-center gap-x-1"
                                        >
                                          <img
                                            className="w-[14px] h-[14px] text-black/60"
                                            src={fac.icon}
                                            alt={fac.facilityName}
                                          />
                                          <p className="text-[10px] text-black/60 text-nowrap">
                                            {fac.facilityName}
                                          </p>
                                        </div>
                                      );
                                    })}
                              </div>
                              <div>
                                <hr />
                              </div>
                              <div className="flex justify-between items-start py-2">
                                <div>
                                  {item.isDhoorbinChoice === 1 && (
                                    <div className="h-full w-full rounded-md flex justify-start items-center gap-x-2 px-2 bg-[#15387533]">
                                      <img
                                        className="w-5 h-5"
                                        src={dhoorbin}
                                        alt=""
                                      />
                                      <p className="text-[10px] font-semibold">
                                        Dhoorbin Choice
                                      </p>
                                    </div>
                                  )}
                                  {item.isCustomerChoice === 1 && (
                                    <div className="h-full w-full rounded-md flex justify-start items-center gap-x-2 px-2 bg-[#15387533]">
                                      <img
                                        className="w-5 h-5"
                                        src={dhoorbin}
                                        alt=""
                                      />
                                      <p className="text-[10px] font-semibold">
                                        Guest Choice
                                      </p>
                                    </div>
                                  )}
                                </div>
                                <div className="flex justify-end items-center gap-x-2">
                                  {item?.rooms?.[0]?.facilities &&
                                    Array.from(
                                      new Set(
                                        item.rooms[0].facilities.flatMap(
                                          (facGroup) =>
                                            facGroup.facilities.map(
                                              (f) => f.facilityName,
                                            ),
                                        ),
                                      ),
                                    )
                                      .slice(0, 5)
                                      .map((name, index) => {
                                        const fac = item.rooms[0].facilities
                                          .flatMap(
                                            (facGroup) => facGroup.facilities,
                                          )
                                          .find((f) => f.facilityName === name);

                                        return (
                                          <div key={index}>
                                            <img
                                              className="w-4 h-4"
                                              src={fac.icon}
                                              alt={fac.facilityName}
                                            />
                                          </div>
                                        );
                                      })}
                                </div>
                              </div>
                              <div className="flex justify-between items-center">
                                <div className="flex items-center justify-start gap-x-1">
                                  <p className="text-xs text-black/60">
                                    {nights || 0}{" "}
                                    {nights > 1 ? "Nights" : "Night"} From
                                  </p>
                                  <p className="text-sm font-bold text-black/80">
                                    ৳{(lowestPrice * nights).toFixed(0)}
                                  </p>
                                </div>
                                <div className="flex items-center gap-x-1 border px-1 py-0.5 rounded-md cursor-pointer  scale-100 hover:scale-105 duration-300">
                                  <div>
                                    <p className="text-xs text-nowrap text-black">
                                      All rooms
                                    </p>
                                  </div>
                                  <div className="text-xs text-black">
                                    <IoIosArrowForward />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <div className="space-y-5">
          <div className="animate-pulse bg-slate-200 w-36 h-5 rounded-full"></div>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {Array.from({ length: 8 }).map((_, index) => {
              return (
                <div
                  key={index}
                  className="animate-pulse bg-slate-200 w-full h-48 rounded-md"
                ></div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default FeaturedProperties;
